import { err, ok } from '@easeltv/fail';

/**
 * getLocalStorage
 *
 * "Fail" safe version of `localStorage.getItem()`
 *
 * @param key - Key to get value from
 * @returns
 */
export const getLocalStorage = (key: string) => {
    try {
        const res = window.localStorage.getItem(key);

        return ok(res ?? undefined);
    } catch (error) {
        return err({
            userMessage: 'Failed to get from localStorage',
            key: 'localStorage.get.failed',
            data: error,
        });
    }
};

/**
 * getLocalStorage
 *
 * "Fail" safe version of `localStorage.setItem()`
 *
 * @param key - Key to set value at
 * @param value - Value to set
 * @returns
 */
export const setLocalStorage = (key: string, value: string) => {
    try {
        const res = window.localStorage.setItem(key, value);

        return ok(res);
    } catch (error) {
        return err({
            userMessage: 'Failed to get from localStorage',
            key: 'localStorage.get.failed',
            data: error,
        });
    }
};
